export const FieldTypeEnum = {
    Integer: "Integer",
    Text: "Text",
    Datetime: "Datetime",
    Relation: "Relation",
    Decimal: "Decimal",
    Boolean: "Boolean",
    Attachment: "Attachment",
    Currency: "Currency",
    Dropdown: "Dropdown",
    Date: "Date",
    Time: "Time",
    Id: "Id",
    ReferenceColumn: "ReferenceColumn"
}
